import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';

import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { AuthContext } from '../../Authentication/AuthContext';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import { StilingueSpreadsheetUploadInput } from './StilingueSpreadsheetUploadInput';
import { StilingueSpreadsheetUploadModel } from '../../../Models/StilingueSpreadsheetUploadModel';
import StilingueSpreadsheetService from '../../../Services/StilingueSpreadsheetService';
import { StilingueSpreadsheetUploadResult } from './StilingueSpreadsheetUploadResult';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { UploadStilingueResultProps, uploadStilingueResultPropsInitial } from '../../../Models/UploadStilingueResultPropsModel';

export function StilingueSpreadsheetUpload() {

    const authContext = React.useContext(AuthContext);

    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [file, setFile] = React.useState<File | null>(null);
    const [resultUpload, setResultUpload] = React.useState<UploadStilingueResultProps>(uploadStilingueResultPropsInitial);

    async function uploadSpreadsheet(data: StilingueSpreadsheetUploadModel, file: File) {
        setFile(file);

        const formData = new FormData();
        formData.append('documentData', JSON.stringify(data));
        formData.append('file', file);

        setStatus(StatusUpload.LOADING);

        StilingueSpreadsheetService
            .postSpreadsheet(authContext.login.user.id, formData)
            .then((res: AxiosResponse) => {
                setResultUpload({ ...res.data.object, status: StatusResult.SUCCESS });
            })
            .catch((error: AxiosError) => {
                const errorResponse: IErrorResponse = ErrorHelper(error);
                setResultUpload({ message: errorResponse.message,
                    title: 'Exibir detalhes do problema',
                    property: errorResponse.errorList[0].property,
                    status: StatusResult.ERROR });
            })
            .finally(() => setStatus(StatusUpload.FINISH));
    }

    return (
        <>
            {status === StatusUpload.INPUT && (
                <StilingueSpreadsheetUploadInput
                    onUpload={(data: StilingueSpreadsheetUploadModel, file: File) => uploadSpreadsheet(data, file)}/> )}
            {status === StatusUpload.LOADING && (
                <UploadLoading nameFile={file?.name ?? ''} />)}
            {status === StatusUpload.FINISH && (
                <StilingueSpreadsheetUploadResult
                    nameFile={file?.name ?? ''}
                    result={resultUpload}
                    onClickNewUpload={() => { setStatus(StatusUpload.INPUT); }} />
            )}
        </>
    );
}